import { getDistance, convertDistance } from 'geolib'

export function getDistanceFromUser({ latitude, longitude, visitorLatLong }) {
  if (!latitude || !longitude) {
    return Number.MAX_SAFE_INTEGER
  }

  if (visitorLatLong) {
    const visitorCoordinates = visitorLatLong.split(',')
    const distance = getDistance(
      {
        latitude: visitorCoordinates[0],
        longitude: visitorCoordinates[1],
      },
      { latitude, longitude },
    )
    return convertDistance(distance, 'mi')
  }

  return Number.MAX_SAFE_INTEGER
}

export const amountIsFree = (amount, currencySymbol) => {
  if (typeof amount === 'string') {
    return amount.includes(`${currencySymbol}0`)
  }
  return Number.parseFloat(amount) === 0
}

export const formatAmount = (
  amount,
  currencySymbol,
  currencyUnits,
  skipZeroDecimal = false,
  skipFree = false,
) => {
  if (!amount && amount !== 0) return ''
  if (!skipFree && (parseFloat(amount) === 0 || amountIsFree(amount, currencySymbol))) return 'Free'
  if (!amount.toString().includes(currencySymbol)) {
    const parsedAmount = parseFloat(amount)
    // remove .00 from amount
    const skipDecimal = !!(
      skipZeroDecimal && parsedAmount.toFixed(2).toString().split('.')[1] === '00'
    )
    return `${currencySymbol}${parseFloat(amount).toFixed(skipDecimal ? 0 : currencyUnits)}`
  }
  return amount
}

export const getStateCodeFromRegionName = ({
  region,
  usStates,
}: {
  region: String
  usStates: { [abbreviation: string]: string }
}) => {
  if (!region) return null

  /* eslint-disable no-restricted-syntax */
  for (const key in usStates) {
    if (Object.prototype.hasOwnProperty.call(usStates, key)) {
      if (usStates[key]?.toLowerCase() === region?.toLowerCase()) {
        return key
      }
    }
  }

  return null
}
